import { FormContextValues, NumberPatternType } from '@dreryk/react-common';

import { isNull } from '~libs.typescript';

import { translationKeys } from '../../../translations';

import { GroupSessionsMaxAgeFieldFormBeanPart } from './GroupSessionsMaxAgeField.types';
import { StyledNumberInput } from './GroupSessionsMaxAgeField.styled';

const MAX_AGE_MAX_VALUE = 100;
const MAX_AGE_MIN_VALUE = 1;
const MAX_AGE_STEP_VALUE = 1;
const MAX_AGE_DEFAULT_VALUE = 100;

type GroupSessionsMaxAgeFieldProps = Pick<
   FormContextValues<GroupSessionsMaxAgeFieldFormBeanPart>,
   'register' | 'getValue' | 'setValue'
>;

export const GroupSessionsMaxAgeField = (props: GroupSessionsMaxAgeFieldProps): JSX.Element => {
   return (
      <StyledNumberInput
         testId={'maxAge'}
         controller={props.register('maxAge', {
            validate: (value) => {
               const maxAge = value as number | null;
               const minAge = props.getValue('minAge');

               if (isNull(maxAge)) {
                  props.setValue('maxAge', Math.max(minAge ?? MAX_AGE_MIN_VALUE, MAX_AGE_DEFAULT_VALUE));
                  return true;
               }

               if (maxAge > MAX_AGE_MAX_VALUE) {
                  props.setValue('maxAge', MAX_AGE_MAX_VALUE);
                  return true;
               }

               if (minAge && minAge > maxAge) {
                  props.setValue('maxAge', minAge);
                  return true;
               }

               return true;
            },
            required: true,
         })}
         label={translationKeys.maxAge}
         defaultValue={MAX_AGE_DEFAULT_VALUE}
         stepValue={MAX_AGE_STEP_VALUE}
         pattern={NumberPatternType.POSITIVE_INTEGER}
      />
   );
};
